import FS from '../FetchService';

export default class SocketService {
  static async getAuthToken() {
    return FS.get('/websocket');
  }
}
